import DEVICE_TYPES from '../../enums/device/deviceTypes';
import {selectIotDeviceData} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import * as iotErrorModeTypes from '../iot/iotErrorModeTypes';

const DIAGNOSTIC_ERRORS = {
    HOLDER_BATTERY_CHARGER_DEFECT: 0,
    CHARGER_BATTERY_CHARGING_TIMEOUT: 1,
    CHARGER_BATTERY_CHARGER_DEFECT: 2,
    SELF_TEST_FAILURE: 3,
    CHARGE_TEMPERATURE_OUT_OF_RANGE: 4,
    HOLDER_SYSTEM_DEFECT: 5,
    TIMEOUT_OF_HOLDER_CHARGE: 6,
    HOLDER_BATTERY_TEMPERATURE_OUTSIDE_OPERATING_RANGE: 7,
    HOLDER_IDENTIFICATION_FAILURE: 8,
    HOLDER_COMMUNICATION_ERROR: 9,
    PAD_CONNECTION_PROBLEM: 10,
    HEATING_HARDWARE_SAFETY_TRIGGERED: 11,
    HEATING_UNEXPECTED_VOLTAGE_WHEN_SWITCHED_OFF: 12,
    HEATING_NO_VOLTAGE_MINUS_WHEN_VOLTAGE_SWITCHED_ON: 13,
    HEATING_NO_VOLTAGE_PLUS_WHEN_VOLTAGE_SWITCHED_ON: 14,
    POWER_DISTRIBUTION_FAILURE: 15,
    HEATING_CANNOT_START_HARDWARE_SAFETY: 16,
    HEATING_POWER_DISTRIBUTION_FAILURE: 17,
    INTERNAL_ERROR_ADC_COMPLETION_TIMEOUT: 18,
    ENVIRONMENT_LOW_MCU_VOLTAGE: 19,
    SYSTEM_FAULT_EXTERNAL_VOLTAGE_REFERENCE_FAILURE: 20,
    SYS_FAULT_HEATER_BROKEN_OR_ABSENT: 21,
    UNEXPECTED_HEATER_WHEN_VOLTAGE_SWITCHED_ON: 22,
    INVALID_MANUFACTURING_INFORMATION_BLOCK_CRC: 23,
    HEATING_REGULATION_CURRENT_TOO_LOW_WHILE_HEATING: 24,
    HEATING_REGULATION_CURRENT_TOO_HIGH_WHILE_HEATING: 25,
    HEATING_REGULATION_HEATER_TEMPERATURE_ABOVE_LIMIT: 26,
    HEATING_REGULATION_HEATER_POWER_OUT_OF_RANGE: 27,
    SYSTEM_FAULT_RTC_OSCILLATOR_FAULT: 28,
    TOO_MUCH_UNEXPECTED_DUTY_CYCLE_VARIATIONS: 29,
    ENVIRONMENT_HIGH_MCU_VOLTAGE: 30,
    BANK_CHARGER_BQ2589X_FAULTS: 31,
    LED_DRIVER_LP5523_FAILURES: 32,
    POCKET_CHARGER_DOOR_SWITCH_ERROR: 33,
    TEMPERATURE_OUT_OF_RANGE_FOR_CHARGING: 34,
    HOLDER_CHARGING_DURATION_EXCEEDED: 35,
    HOLDER_TEMPERATURE_OUT_OF_RANGE: 36,
    HOLDER_CHARGER_DEFECT: 37,
    HOLDER_CHARGE_ERROR: 38,
    HOLDER_BAD_COMMUNICATION: 39,
    HOLDER_END_OF_BATTERY_LIFE: 40,
    AUTHENTICATION_FAILURE: 41,
    JTAG_RDP_LEVEL_ERROR: 42,
    EEPROM_INTEGRITY_FAILURE: 43,
    BUTTON_S1_PULL_UP_RESISTOR_TEST_FAILURE: 44,
    INVALID_CALIBRATION_DATA_CRC: 45,
    EXTERNAL_VOLTAGE_REFERENCE_FAILURE: 46,
    LED_DRIVER_CHIP_LM3535_I2C_COMM_ERROR: 47,
    LED_DRIVER_VLED_EN_PULL_DOWN_TEST_FAILURE: 48,
    VIBRATOR_VMG_PULL_DOWN_TEST_FAILURE: 49,
    BATTERY_CHARGER_CHIP_BQ24250_I2C_COMM_ERROR: 50,
    BQ24250_CHG_EN_PULL_DOWN_RESISTOR_TEST_FAILURE: 51,
    HEATING_HCM_SWITCHES_ERROR: 52,
    RESISTANCE_CHAIN_FAULT_DETECTED: 53,
    HEATER_RESISTANCE_FAULT_DETECTED: 54,
    LOW_SIDE_FAULT_DETECTED: 55,
    HCM_HMG_PULL_DOWN_RESISTOR_TEST_FAILURE: 56,
    BATTERY_VOLTAGE_TOO_LOW: 57,
    AMBIENT_TEMPERATURE_TOO_LOW: 58,
    AMBIENT_TEMPERATURE_TOO_HIGH: 59,
    BATTERY_CHARGER_FAULT: 60,
    BATTERY_CHARGING_DURATION_EXCEEDED: 61,
    HEATING_DURATION_EXCEEDED: 62,
    DUTY_CYCLE_TOO_LOW_WHILE_HEATING: 63,
    ERROR_HEATER_PMOS_OPEN: 64,
    CODENTIFY_CAN_BE_READ_BUT_DEVICE_NOT_IDENTIFIABLE: 65,
    HOLDER_CANNOT_COMMUNICATE_WITH_THE_FUEL_GAUGE: 66,
    MCU_I2C_BUS_DRIVER: 67,
    LP5523_LED_DRIVER_I2C_BUS_NACK: 68,
    BQ25895_DRIVER_I2C_BUS_NACK: 69,
    MCU_EEPROM_READ_WRITE_FAILURE: 70,
    EXTERNAL_FLASH_FAILURE: 71,
    NTC_LOW_TEMPERATURE: 72,
    NTC_HIGH_TEMPERATURE: 73,
    BQ25895_INIT_FAILURE: 74,
    BQ25895_CONFIGURATION_FAILURE: 75,
    BQ25895_FAULTS: 76,
    SYS_VOLTAGE_TOO_LOW: 77,
    EXTERNAL_FLASH_DRIVER_INIT: 78,
    BLE_CHIP_INIT: 79,
    TOO_HIGH_HEATER_TEMPERATURE_DURING_HEATING: 80,
    MCU_LOW_TEMPERATURE: 81,
    MCU_HIGH_TEMPERATURE: 82,
    HCM_SWITCHES_TEST_FAILED: 83,
    HEATING_TIMEOUT_ERROR: 84,
    BIMT_POWER_ON_SELF_TEST: 85,
};

export const M3_TEMPERATURE_PRIORITY_ERRORS = [
    DIAGNOSTIC_ERRORS.CHARGE_TEMPERATURE_OUT_OF_RANGE,
    DIAGNOSTIC_ERRORS.HOLDER_BATTERY_TEMPERATURE_OUTSIDE_OPERATING_RANGE,
    DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_LOW,
    DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_HIGH,
    DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_TEMPERATURE_ABOVE_LIMIT,
    DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_POWER_OUT_OF_RANGE,
    DIAGNOSTIC_ERRORS.TEMPERATURE_OUT_OF_RANGE_FOR_CHARGING,
    DIAGNOSTIC_ERRORS.HOLDER_TEMPERATURE_OUT_OF_RANGE,
    DIAGNOSTIC_ERRORS.NTC_HIGH_TEMPERATURE,
    DIAGNOSTIC_ERRORS.NTC_LOW_TEMPERATURE,
    DIAGNOSTIC_ERRORS.MCU_LOW_TEMPERATURE,
    DIAGNOSTIC_ERRORS.MCU_HIGH_TEMPERATURE,
];

export const M3_BATTERY_PRIORITY_ERRORS = [
    DIAGNOSTIC_ERRORS.BANK_CHARGER_BQ2589X_FAULTS,
    DIAGNOSTIC_ERRORS.BATTERY_VOLTAGE_TOO_LOW,
    DIAGNOSTIC_ERRORS.BATTERY_CHARGER_FAULT,
];

export const BROKEN_BLADE_L0_CODE = 'C002';

export const getErrorMapping = (isHolder) => {
    const state = getState();
    const iotDevice = selectIotDeviceData(state);

    if (!iotDevice) return [];

    const type = iotDevice.device?.type;

    if (!type) return [];

    // eslint-disable-next-line default-case
    switch (type) {
        case DEVICE_TYPES.DEV_TYPE_V24_CHARGER:
        case DEVICE_TYPES.DEV_TYPE_V24P_CHARGER:
            return isHolder ? CHARGER_24_HOLDER_ERRORS : CHARGER_24_CHARGER_ERRORS;
        case DEVICE_TYPES.DEV_TYPE_P1V30M:
            return isHolder ? [] : DEVICE_30M;
        case DEVICE_TYPES.DEV_TYPE_P1V31_CHARGER:
        case DEVICE_TYPES.DEV_TYPE_P1V30_CHARGER:
            return isHolder ? CHARGER_30_AND_31_HOLDER_ERRORS : CHARGER_30_AND_31_ERRORS;
    }

    return [];
};

export const getWarningMapping = (isHolder) => {
    const state = getState();
    const iotDevice = selectIotDeviceData(state);

    if (!iotDevice) return [];

    const type = iotDevice.device?.type;

    if (!type) return [];

    // eslint-disable-next-line default-case
    switch (type) {
        case DEVICE_TYPES.DEV_TYPE_V24_CHARGER:
            return isHolder ? CHARGER_24_HOLDER_WARNING : CHARGER_24_CHARGER_WARNINGS;
        case DEVICE_TYPES.DEV_TYPE_V24P_CHARGER:
            return isHolder ? CHARGER_24PLUS_HOLDER_WARNING : CHARGER_24_CHARGER_WARNINGS;
        case DEVICE_TYPES.DEV_TYPE_P1V30M:
            return isHolder ? [] : DEVICE_30M;
        case DEVICE_TYPES.DEV_TYPE_P1V31_CHARGER:
        case DEVICE_TYPES.DEV_TYPE_P1V30_CHARGER:
            return isHolder ? CHARGER_30_AND_31_HOLDER_WARNINGS : CHARGER_30_AND_31_WARNING;
    }

    return [];
};

export const getHolderErrorMapping = () => {
    const state = getState();
    const iotDevice = selectIotDeviceData(state);

    if (!iotDevice) return [];

    const type = iotDevice.holder?.type;

    if (!type) return [];

    // eslint-disable-next-line default-case
    switch (type) {
        case DEVICE_TYPES.DEV_TYPE_V24_HOLDER:
            return HOLDER_24_ERRORS;
        case DEVICE_TYPES.DEV_TYPE_V24P_HOLDER:
            return HOLDER_24PLUS_ERRORS;
        case DEVICE_TYPES.DEV_TYPE_P1V31_HOLDER:
        case DEVICE_TYPES.DEV_TYPE_P1V30_HOLDER:
            return HOLDER_30_AND_31_ERRORS;
    }

    return [];
};

const CHARGER_24_CHARGER_ERRORS = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HOLDER_BATTERY_CHARGER_DEFECT,
        l0Code: 'B038',
        l1Code: 'B038',
        qureCode: 'CB2',
        isHolder: false,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.CHARGER_BATTERY_CHARGING_TIMEOUT,
        l0Code: 'B032',
        l1Code: 'B032',
        qureCode: 'CB9',
        isHolder: false,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.CHARGER_BATTERY_CHARGER_DEFECT,
        l0Code: 'B104',
        l1Code: 'B008',
        qureCode: 'CB1',
        isHolder: false,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.SELF_TEST_FAILURE,
        l0Code: 'B038',
        l1Code: 'B038',
        qureCode: 'CB2',
        isHolder: false,
    },
];

const CHARGER_24_CHARGER_WARNINGS = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.CHARGE_TEMPERATURE_OUT_OF_RANGE,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'CA9',
        isHolder: false,
    },
];

const CHARGER_24_HOLDER_ERRORS = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HOLDER_SYSTEM_DEFECT,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.TIMEOUT_OF_HOLDER_CHARGE,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HOLDER_BATTERY_TEMPERATURE_OUTSIDE_OPERATING_RANGE,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'CA9',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_IDENTIFICATION_FAILURE,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
];

const CHARGER_24_HOLDER_WARNING = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_COMMUNICATION_ERROR,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.PAD_CONNECTION_PROBLEM,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HOLDER_END_OF_BATTERY_LIFE,
        l0Code: 'B101',
        l1Code: 'B019',
        qureCode: 'CB1',
        isHolder: true,
    },
];

const CHARGER_24PLUS_HOLDER_WARNING = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_COMMUNICATION_ERROR,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.PAD_CONNECTION_PROBLEM,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HOLDER_END_OF_BATTERY_LIFE,
        l0Code: 'B043',
        l1Code: 'B043',
        qureCode: 'CB1',
        isHolder: true,
    },
];

const HOLDER_24_ERRORS = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_HARDWARE_SAFETY_TRIGGERED,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_UNEXPECTED_VOLTAGE_WHEN_SWITCHED_OFF,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_NO_VOLTAGE_MINUS_WHEN_VOLTAGE_SWITCHED_ON,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_NO_VOLTAGE_PLUS_WHEN_VOLTAGE_SWITCHED_ON,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.POWER_DISTRIBUTION_FAILURE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 5,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_CANNOT_START_HARDWARE_SAFETY,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 6,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_POWER_DISTRIBUTION_FAILURE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 7,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.INTERNAL_ERROR_ADC_COMPLETION_TIMEOUT,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 8,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.ENVIRONMENT_LOW_MCU_VOLTAGE,
        l0Code: 'B103',
        l1Code: 'B015',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 9,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.EXTERNAL_VOLTAGE_REFERENCE_FAILURE,
        l0Code: 'B103',
        l1Code: 'B015',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 10,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.SYS_FAULT_HEATER_BROKEN_OR_ABSENT,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 11,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.UNEXPECTED_HEATER_WHEN_VOLTAGE_SWITCHED_ON,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 12,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: true,
    },
    {
        shift: 13,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_HIGH,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: true,
    },
    {
        shift: 14,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.INVALID_MANUFACTURING_INFORMATION_BLOCK_CRC,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 15,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_CURRENT_TOO_LOW_WHILE_HEATING,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 16,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_CURRENT_TOO_HIGH_WHILE_HEATING,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 17,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_TEMPERATURE_ABOVE_LIMIT,
        l0Code: 'B103',
        l1Code: 'B015',
        qureCode: 'HA1',
        isHolder: true,
    },
    {
        shift: 18,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_POWER_OUT_OF_RANGE,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 19,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.SYSTEM_FAULT_RTC_OSCILLATOR_FAULT,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 20,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.TOO_MUCH_UNEXPECTED_DUTY_CYCLE_VARIATIONS,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 21,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.ENVIRONMENT_HIGH_MCU_VOLTAGE,
        l0Code: 'B103',
        l1Code: 'B015',
        qureCode: 'HB2',
        isHolder: true,
    },
];

const HOLDER_24PLUS_ERRORS = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_HARDWARE_SAFETY_TRIGGERED,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_UNEXPECTED_VOLTAGE_WHEN_SWITCHED_OFF,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_NO_VOLTAGE_MINUS_WHEN_VOLTAGE_SWITCHED_ON,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_NO_VOLTAGE_PLUS_WHEN_VOLTAGE_SWITCHED_ON,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.POWER_DISTRIBUTION_FAILURE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 5,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_CANNOT_START_HARDWARE_SAFETY,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 6,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_POWER_DISTRIBUTION_FAILURE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 7,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.INTERNAL_ERROR_ADC_COMPLETION_TIMEOUT,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 8,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.ENVIRONMENT_LOW_MCU_VOLTAGE,
        l0Code: 'B103',
        l1Code: 'B040',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 9,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.EXTERNAL_VOLTAGE_REFERENCE_FAILURE,
        l0Code: 'B103',
        l1Code: 'B040',
        qureCode: 'HB2',
        isHolder: true,
    },
    {
        shift: 10,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.SYS_FAULT_HEATER_BROKEN_OR_ABSENT,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 11,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.UNEXPECTED_HEATER_WHEN_VOLTAGE_SWITCHED_ON,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 12,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: true,
    },
    {
        shift: 13,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_HIGH,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: true,
    },
    {
        shift: 14,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.INVALID_MANUFACTURING_INFORMATION_BLOCK_CRC,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 15,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_CURRENT_TOO_LOW_WHILE_HEATING,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 16,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_CURRENT_TOO_HIGH_WHILE_HEATING,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 17,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_TEMPERATURE_ABOVE_LIMIT,
        l0Code: 'B103',
        l1Code: 'B040',
        qureCode: 'HA1',
        isHolder: true,
    },
    {
        shift: 18,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_POWER_OUT_OF_RANGE,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 19,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.SYSTEM_FAULT_RTC_OSCILLATOR_FAULT,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 20,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.TOO_MUCH_UNEXPECTED_DUTY_CYCLE_VARIATIONS,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 21,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.ENVIRONMENT_HIGH_MCU_VOLTAGE,
        l0Code: 'B103',
        l1Code: 'B040',
        qureCode: 'HB2',
        isHolder: true,
    },
];

const CHARGER_30_AND_31_ERRORS = [
    {
        shift: 2,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BANK_CHARGER_BQ2589X_FAULTS,
        l0Code: 'B104',
        l1Code: 'B008',
        qureCode: 'CB1',
        isHolder: false,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.SELF_TEST_FAILURE,
        l0Code: 'B038',
        l1Code: 'B038',
        qureCode: 'CB2',
        isHolder: false,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.LED_DRIVER_LP5523_FAILURES,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: false,
    },
    {
        shift: 5,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.POCKET_CHARGER_DOOR_SWITCH_ERROR,
        l0Code: 'C101',
        l1Code: 'C030',
        qureCode: 'CC5',
        isHolder: false,
    },
];

const CHARGER_30_AND_31_WARNING = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.TEMPERATURE_OUT_OF_RANGE_FOR_CHARGING,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'CA9',
        isHolder: false,
    },
];

const CHARGER_30_AND_31_HOLDER_ERRORS = [
    {
        shift: 1,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_CHARGING_DURATION_EXCEEDED,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HOLDER_TEMPERATURE_OUT_OF_RANGE,
        l0Code: 'A101',
        l1Code: 'A101',
        qureCode: 'CA9',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_IDENTIFICATION_FAILURE,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_CHARGER_DEFECT,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
    {
        shift: 5,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_CHARGE_ERROR,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
    {
        shift: 6,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_COMMUNICATION_ERROR,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: true,
    },
];

const CHARGER_30_AND_31_HOLDER_WARNINGS = [
    {
        shift: 2,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.HOLDER_BAD_COMMUNICATION,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HOLDER_END_OF_BATTERY_LIFE,
        l0Code: 'B043',
        l1Code: 'B043',
        qureCode: 'HB12',
        isHolder: true,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.AUTHENTICATION_FAILURE,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'CB5',
        isHolder: true,
    },
];

const HOLDER_30_AND_31_ERRORS = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.JTAG_RDP_LEVEL_ERROR,
        l0Code: 'B101',
        l1Code: 'B101',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.EEPROM_INTEGRITY_FAILURE,
        l0Code: 'B101',
        l1Code: 'B101',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.BUTTON_S1_PULL_UP_RESISTOR_TEST_FAILURE,
        l0Code: 'C101',
        l1Code: 'C027',
        qureCode: 'HC4',
        isHolder: true,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.INVALID_MANUFACTURING_INFORMATION_BLOCK_CRC,
        l0Code: 'B101',
        l1Code: 'B101',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.INVALID_CALIBRATION_DATA_CRC,
        l0Code: 'B101',
        l1Code: 'B101',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 5,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.EXTERNAL_VOLTAGE_REFERENCE_FAILURE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 6,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.LED_DRIVER_CHIP_LM3535_I2C_COMM_ERROR,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 7,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.LED_DRIVER_VLED_EN_PULL_DOWN_TEST_FAILURE,
        l0Code: 'B101',
        l1Code: 'B101',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 8,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.VIBRATOR_VMG_PULL_DOWN_TEST_FAILURE,
        l0Code: 'B037',
        l1Code: 'B037',
        qureCode: 'HB4',
        isHolder: true,
    },
    {
        shift: 9,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BATTERY_CHARGER_CHIP_BQ24250_I2C_COMM_ERROR,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: true,
    },
    {
        shift: 10,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.BQ24250_CHG_EN_PULL_DOWN_RESISTOR_TEST_FAILURE,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: true,
    },
    {
        shift: 11,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.HEATING_HCM_SWITCHES_ERROR,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 12,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.RESISTANCE_CHAIN_FAULT_DETECTED,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 13,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATER_RESISTANCE_FAULT_DETECTED,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: true,
    },
    {
        shift: 14,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.LOW_SIDE_FAULT_DETECTED,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 15,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HCM_HMG_PULL_DOWN_RESISTOR_TEST_FAILURE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 16,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.BATTERY_VOLTAGE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: true,
    },
    {
        shift: 17,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA2',
        isHolder: true,
    },
    {
        shift: 18,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.AMBIENT_TEMPERATURE_TOO_HIGH,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA2',
        isHolder: true,
    },
    {
        shift: 19,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BATTERY_CHARGER_FAULT,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: true,
    },
    {
        shift: 20,
        mode: iotErrorModeTypes.M2,
        code: DIAGNOSTIC_ERRORS.BATTERY_CHARGING_DURATION_EXCEEDED,
        l0Code: 'B006',
        l1Code: 'B006',
        qureCode: 'HB6',
        isHolder: true,
    },
    {
        shift: 21,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_DURATION_EXCEEDED,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 23,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.HEATING_REGULATION_HEATER_TEMPERATURE_ABOVE_LIMIT,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 24,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.DUTY_CYCLE_TOO_LOW_WHILE_HEATING,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 25,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.ERROR_HEATER_PMOS_OPEN,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
    {
        shift: 26,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.CODENTIFY_CAN_BE_READ_BUT_DEVICE_NOT_IDENTIFIABLE,
        l0Code: 'C101',
        l1Code: 'B022',
        qureCode: 'HB3',
        isHolder: true,
    },
    {
        shift: 27,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.HOLDER_CANNOT_COMMUNICATE_WITH_THE_FUEL_GAUGE,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: true,
    },
];

const DEVICE_30M = [
    {
        shift: 0,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.MCU_I2C_BUS_DRIVER,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB1',
        isHolder: false,
    },
    {
        shift: 1,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.LP5523_LED_DRIVER_I2C_BUS_NACK,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: false,
    },
    {
        shift: 2,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BQ25895_DRIVER_I2C_BUS_NACK,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: false,
    },
    {
        shift: 3,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.MCU_EEPROM_READ_WRITE_FAILURE,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: false,
    },
    {
        shift: 4,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.EXTERNAL_FLASH_FAILURE,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: false,
    },
    {
        shift: 5,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.NTC_LOW_TEMPERATURE,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: false,
    },
    {
        shift: 6,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.NTC_HIGH_TEMPERATURE,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: false,
    },
    {
        shift: 7,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BQ25895_INIT_FAILURE,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: false,
    },
    {
        shift: 8,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BQ25895_CONFIGURATION_FAILURE,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: false,
    },
    {
        shift: 9,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BQ25895_FAULTS,
        l0Code: 'B103',
        l1Code: 'B041',
        qureCode: 'HB6',
        isHolder: false,
    },
    {
        shift: 10,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.SYS_VOLTAGE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA3',
        isHolder: false,
    },
    {
        shift: 11,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.BATTERY_VOLTAGE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HB11',
        isHolder: false,
    },
    {
        shift: 12,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.LED_DRIVER_LP5523_FAILURES,
        l0Code: 'B042',
        l1Code: 'B102',
        qureCode: 'HB1',
        isHolder: false,
    },
    {
        shift: 13,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.EXTERNAL_FLASH_DRIVER_INIT,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: false,
    },
    {
        shift: 14,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.BLE_CHIP_INIT,
        l0Code: 'B105',
        l1Code: 'B047',
        qureCode: 'CB6',
        isHolder: false,
    },
    {
        shift: 15,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.BATTERY_VOLTAGE_TOO_LOW,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: false,
    },
    {
        shift: 17,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.RESISTANCE_CHAIN_FAULT_DETECTED,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: false,
    },
    {
        shift: 18,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATER_RESISTANCE_FAULT_DETECTED,
        l0Code: 'C002',
        l1Code: 'C002',
        qureCode: 'HC2',
        isHolder: false,
    },
    {
        shift: 19,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.TOO_HIGH_HEATER_TEMPERATURE_DURING_HEATING,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: false,
    },
    {
        shift: 20,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.DUTY_CYCLE_TOO_LOW_WHILE_HEATING,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: false,
    },
    {
        shift: 21,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.LOW_SIDE_FAULT_DETECTED,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB1',
        isHolder: false,
    },
    {
        shift: 22,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.MCU_LOW_TEMPERATURE,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HA9',
        isHolder: false,
    },
    {
        shift: 23,
        mode: iotErrorModeTypes.M3,
        code: DIAGNOSTIC_ERRORS.MCU_HIGH_TEMPERATURE,
        l0Code: 'A101',
        l1Code: 'A001',
        qureCode: 'HB5',
        isHolder: false,
    },
    {
        shift: 24,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.HCM_SWITCHES_TEST_FAILED,
        l0Code: 'B102',
        l1Code: 'B042',
        qureCode: 'HB10',
        isHolder: false,
    },
    {
        shift: 25,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.HEATING_TIMEOUT_ERROR,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: false,
    },
    {
        shift: 30,
        mode: iotErrorModeTypes.M1,
        code: DIAGNOSTIC_ERRORS.SELF_TEST_FAILURE,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB10',
        isHolder: false,
    },
    {
        shift: 31,
        mode: iotErrorModeTypes.M4,
        code: DIAGNOSTIC_ERRORS.BIMT_POWER_ON_SELF_TEST,
        l0Code: 'B101',
        l1Code: 'B999',
        qureCode: 'HB3',
        isHolder: false,
    },
];
